// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"error-page-component_uk-open__t8y5W","grecaptcha-badge":"error-page-component_grecaptcha-badge__0bt3A","not-found":"error-page-component_not-found__7t3qo","not-found-container":"error-page-component_not-found-container__VDI2F","not-found-title":"error-page-component_not-found-title__PTolA"};
    if(module.hot) {
      // 1750775018623
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  